export const { REACT_APP_BACKEND_API_URL } = process.env;
export const { REACT_APP_QUOTATION_SERVICE_API_URL } = process.env;
export const { REACT_APP_BLOG_IMG_URL } = process.env;
